import { Controller } from "stimulus"

// Adminkit scrolls the main column, not always window — scroll every likely container.
export default class extends Controller {
  go() {
    const smooth = { top: 0, left: 0, behavior: "smooth" }
    const instant = { top: 0, left: 0, behavior: "auto" }

    const tryScroll = (el, opts) => {
      if (!el) return
      try {
        if (typeof el.scrollTo === "function") {
          el.scrollTo(opts)
        } else {
          el.scrollTop = 0
        }
      } catch (_e) {
        el.scrollTop = 0
      }
    }

    const candidates = [
      document.scrollingElement,
      document.documentElement,
      document.body,
      document.querySelector(".main"),
      document.querySelector("main.content")
    ].filter(Boolean)

    candidates.forEach((el) => tryScroll(el, smooth))

    try {
      window.scrollTo(smooth)
    } catch (_e) {
      tryScroll(window, instant)
    }

    // Fallback: if smooth didn't run (older browsers), force instant on next frame
    requestAnimationFrame(() => {
      candidates.forEach((el) => {
        if (el.scrollTop > 0) tryScroll(el, instant)
      })
      if (window.scrollY > 0) {
        try {
          window.scrollTo(0, 0)
        } catch (_e2) {
          window.scrollTo(0, 0)
        }
      }
    })
  }
}
